import { IScrollViewItem } from '../../Shared/ScrollView/IScrollViewItem';
import { PlayerAvatar } from '../../Shared/PlayerAvatar';
import { Rectangle, Sprite } from 'pixi.js';
import { createOutlineText } from '../../../Utils/Utils';
import { ISDKLeaderboardPlayer } from '../../../SDK/SDKleaderboards';
import DateUtils from '../../../Utils/DateUtils';

export class LevelLeaderboardItem extends PIXI.Container implements IScrollViewItem {
    /*  private playerAvatar: PlayerAvatar;*/

    constructor(player: ISDKLeaderboardPlayer, place: number, timed: boolean) {
        super();

        const frame = new PIXI.Sprite(
            PIXI.utils.TextureCache['mapui/leaderboard-playertag-avatarframe']
        );
        frame.anchor.set(0.5);
        frame.scale.set(1.5);
        if (player.user.isCurrentUser) {
            frame.tint = 0x46d0ff;
        }
        const avatar /*= this.playerAvatar */ = new PlayerAvatar(
            player.user.avatarUrl,
            frame.width * 0.8,
            frame.height * 0.8
        );

        const playerName = createOutlineText(
            player.user.handle.split(' ')[0],
            new Rectangle(0, 0, frame.width, frame.height),
            'Baloo',
            24,
            18
        );
        const scoreValue = timed
            ? DateUtils.levelTimeToString(player.score.valueOf())
            : player.score.toString();
        const score = createOutlineText(
            scoreValue,
            new Rectangle(0, 0, frame.width, frame.height),
            'Baloo',
            24,
            18
        );

        frame.y = avatar.y = frame.height / 1.9;
        score.y = frame.y + frame.height / 1.9;
        this.addChild(playerName, avatar, frame, score);

        if (place <= 3) {
            const rank = new Sprite(
                PIXI.utils.TextureCache[`mapui/leaderboard-playertag-rank${place}`]
            );
            rank.anchor.set(0.5);
            rank.scale.set(0.7);
            rank.position.set(
                frame.x + frame.width / 2 - rank.width / 2,
                frame.y + frame.height / 2 - rank.height / 2
            );
            this.addChild(rank);
        }
    }

    public setDragging(dragging: boolean): void {}
}
